<template>
  <v-btn
    x-small
    :color="color"
    class="mx-1 fn-btn"
    :disabled="disabled"
    :style="{ width: `${size}px`, height: `${size}px` }"
    @click="_fnClick"
  >
    <v-icon small>{{ icon }}</v-icon>
  </v-btn>
</template>

<script>
export default {
  props: {
    icon: String,
    color: {
      type: String,
      default: "primary",
    },
    size: {
      type: Number,
      defalut: 24,
    },
    disabled: Boolean,
  },
  methods: {
    _fnClick() {
      this.$emit("click");
    },
  },
};
</script>

<style scoped>
.fn-btn {
  min-width: 24px !important;
  width: 24px;
  min-height: 24px;
  height: 24px;
}
</style>
